import { TileLayer, LayersControl } from 'react-leaflet';

// The LayersControlPanel to handle map options (open-source maps)

function LayersControlPanel() {

    const { BaseLayer } = LayersControl;

    return (
        <LayersControl position="topleft">
            <BaseLayer checked name="OpenStreetMap">
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a>'
                />
            </BaseLayer>
            <BaseLayer name="Humanitarian">
                <TileLayer
                    url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                    attribution={
                        '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a> contributors,' +
                        'Tiles style by <a href="https://www.hotosm.org/">Humanitarian OpenStreetMap Team</a> ' +
                        'hosted by <a href="https://www.openstreetmap.fr">OpenStreetMap France</a>'
                    }
                />
            </BaseLayer>
            <BaseLayer name="Topografisch">
                <TileLayer
                    url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                    attribution={
                        'Map data: &copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a> contributors,' +
                        '<a href="https://viewfinderpanoramas.org">SRTM</a> | ' +
                        'Map style: &copy; <a href="https://opentopomap.org/#map=5/49.023/9.998">OpenTopoMap</a> ' +
                        '(<a href="https://creativecommons.org/licenses/by-sa/3.0">CC-BY-SA</a>)'
                    }
                />
            </BaseLayer>
        </LayersControl>
    );
}

export default LayersControlPanel;